<template>
    <div class="">
        <div class="uk-container uk-padding">
            <h1 class="uk-text-center">College of Education & Leadership</h1>
            <hr>
            <h2 class="uk-text-left" >
                Message from the Dean
                <span class="uk-text-muted uk-text-small uk-text-italic"  style="font-variant: none !important;"> Daniel Allida, PhD </span>
            </h2>
            <div class="uk-panel">

                <img class="uk-border-pill uk-align-left@m" src="../assets/DrDanielAllida_Photo1.jpg" width="150" height="150" alt="Border pill">

                <p>
                    It is with utmost pleasure that I welcome you to the College of Education and Leadership at
                    Northern Caribbean University. The College operates through two vibrant and dynamic
                    departments – the Department of Graduate Education and Leadership and the Department of
                    Teacher Education.
                </p>
                <p>
                    Over the years, the College is known to have produced world-class graduates that have made a
                    significant impact on education and leadership in the Caribbean and the International
                    Communities. In choosing the College of Education and Leadership, students can expect to be
                    provided with quality Christian education. Members of faculty are competent, committed and
                    good examples of Christian character and professionalism.
                </p>
                <p>
                    I share with you an inspiring quote from Ellen White, “Students, make your school life as perfect
                    as possible. You will pass over the way but once and precious are the opportunities granted you.
                    You are not only to learn but to practice the lessons of Christ. While obtaining your education,
                    you have the opportunity to tell of the wonderful truths of God’s Word. Improve every
                    opportunity. God will bless every minute spent in this way” (Counsels to Parents and Teachers,
                    pg.554).
                </p>
                <p>
                    Welcome again to Northern Caribbean University. I anticipate a wonderful journey as we learn
                    together in the School of Christ.
                </p>

                <p>
                    Sincerely <br>
                    Dr Daniel Allida <br>
                    Dean, College of Education and Leadership
                </p>
            </div>

        </div>
         <!--        <div style="background-color: gold">
            <div class="uk-container uk-padding-large">

                <div class="uk-child-width-1-2@m" uk-grid>
                    <div>
                        <h3 class="uk-heading-bullet uk-text-bold">Certificate in Special Education</h3>
                        The programme is designed to prepare paraprofessionals to assist trained teachers in the Special
                        Education classroom. Additionally, this course will facilitate trained teachers and other
                        professionals who desire to gain foundation knowledge in Special Education.
                        <br><br>
                        A candidate is successful on completion of 24 credits. Successful completion of this certificate will enable
                        the participants to transfer the credits earned to the Bachelor's degree in Special Education.

                        <br><br><br>
                        <a href="https://apply.aeorion.ncu.edu.jm" target="_blank" class="uk-button uk-button-secondary uk-align-right@m" style="background-color: #033860">
                            Apply Now <span uk-icon="arrow-right"></span>
                        </a>
                    </div>
                    <div>
                        <img src="../assets/children.jpg" style="border-radius: 15px" alt="">
                    </div>
                </div>
            </div>
        </div>-->
        <research />
        <!--<teacher-ed-degrees/>-->
        <el-department-links/>
        <achievers />
        <el-success-story/>
        <intouch />
        <explore-undergrad-programs/>
    </div>
</template>

<script>
import intouch from '@/components/colleges/el/intouch/InTouchEL'
import research from '@/components/colleges/el/research/ResearchEL'
import achievers from '@/components/colleges/el/achievers/AchieversEL'
import ElDepartmentLinks from "../components/colleges/el/links/departmentLinks";
import ElSuccessStory from "../components/colleges/el/stories/successStory";
import ExploreUndergradPrograms from "../components/undergradadmission/exploreUndergradPrograms";
import TeacherEdDegrees from "../components/colleges/el/teacherEdDegrees";
    export default {
        name: "EL",
        components:
        {
            TeacherEdDegrees,
            intouch, research,achievers,ElDepartmentLinks,ElSuccessStory,ExploreUndergradPrograms
        }
    }
</script>

<style scoped>

</style>